namespace $.$$ {
	$mol_style_define( $shm_showcase_demo_echarts, {
		// ECharts заполняет абсолютно позиционируемым элементом область графика.
		Plot: { position: 'relative', height: $mol_style_unit.rem( 20 ) },
	} )
}
